var _path, _rect, _path2, _circle, _path3, _path4, _rect2, _rect3, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoempty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 153,
    viewBox: "0 0 162 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.434 54.8994C168.69 87.1466 155.87 129.137 132.153 145.192C108.436 161.11 74.0781 151.092 45.4892 129.548C16.9004 108.004 -5.66294 75.0711 1.25992 47.901C8.18277 20.731 44.5918 -0.538501 79.5907 0.0103883C114.59 0.422056 148.05 22.7893 158.434 54.8994Z",
    fill: "#EEF1F9",
    fillOpacity: 0.35
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42.4825,
    y: 27.8179,
    width: 75.965,
    height: 100.573,
    rx: 7,
    fill: "#F9FAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5054 113.734C42.5054 69.3439 84.8432 38.3545 106.012 28.4086C116.423 25.4772 120.067 34.1667 120.587 38.878V128.391H53.4368C41.4643 128.391 42.5054 115.828 42.5054 113.734Z",
    fill: "#EEF3F9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120.587,
    cy: 106.993,
    r: 23.1486,
    fill: "#EEF3F9",
    stroke: "#ACC1D4",
    strokeWidth: 3.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.622 102C126.366 101.295 125.9 100.68 125.282 100.236C124.664 99.7906 123.923 99.5357 123.155 99.5034H118.02C116.998 99.5034 116.018 99.898 115.296 100.6C114.574 101.303 114.168 102.255 114.168 103.248C114.168 104.241 114.574 105.194 115.296 105.896C116.018 106.598 116.998 106.993 118.02 106.993H123.155C124.177 106.993 125.156 107.387 125.879 108.09C126.601 108.792 127.007 109.745 127.007 110.738C127.007 111.731 126.601 112.683 125.879 113.386C125.156 114.088 124.177 114.482 123.155 114.482H118.02C117.251 114.45 116.511 114.195 115.893 113.75C115.275 113.305 114.809 112.691 114.553 111.986",
    stroke: "#ACC1D4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120.587 114.839V118.762M120.587 95.2236V99.1467V95.2236Z",
    stroke: "#ACC1D4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48.9021,
    y: 35.3076,
    width: 62.0559,
    height: 22.4685,
    rx: 7,
    fill: "#F9FAFD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 49.972,
    y: 35.3076,
    width: 60.986,
    height: 22.4685,
    rx: 7,
    fill: "#EEF3F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.818 49.7247V42.4473C108.818 39.6858 106.58 37.4473 103.818 37.4473H56.042C53.2805 37.4473 51.042 39.6858 51.042 42.4473V50.6361C51.042 53.3975 53.2805 55.6361 56.042 55.6361H100.709",
    stroke: "#ACC1D4",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.045 85.6431C121.564 85.6107 121.077 85.5942 120.587 85.5942C108.769 85.5942 99.1888 95.1747 99.1888 106.993C99.1888 110.594 100.078 113.988 101.65 116.966C103.613 97.4262 114.167 88.62 122.045 85.6431Z",
    fill: "#F9FAFD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0245 128.392H50.3427C44.8198 128.392 40.3427 123.914 40.3427 118.392V35.6782C40.3427 30.1554 44.8198 25.6782 50.3427 25.6782H108.448C113.97 25.6782 118.448 30.1554 118.448 35.6782V82.4983",
    stroke: "#ACC1D4",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72 96C74.2091 96 76 94.2091 76 92C76 89.7909 74.2091 88 72 88C69.7909 88 68 89.7909 68 92C68 94.2091 69.7909 96 72 96Z",
    fill: "#ACC1D4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M89 96C91.2091 96 93 94.2091 93 92C93 89.7909 91.2091 88 89 88C86.7909 88 85 89.7909 85 92C85 94.2091 86.7909 96 89 96Z",
    fill: "#ACC1D4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55 75C57.2091 75 59 73.2091 59 71C59 68.7909 57.2091 67 55 67C52.7909 67 51 68.7909 51 71C51 73.2091 52.7909 75 55 75Z",
    fill: "#ACC1D4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55 96C57.2091 96 59 94.2091 59 92C59 89.7909 57.2091 88 55 88C52.7909 88 51 89.7909 51 92C51 94.2091 52.7909 96 55 96Z",
    fill: "#ACC1D4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M55 116C57.2091 116 59 114.209 59 112C59 109.791 57.2091 108 55 108C52.7909 108 51 109.791 51 112C51 114.209 52.7909 116 55 116Z",
    fill: "#ACC1D4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M72 116C74.2091 116 76 114.209 76 112C76 109.791 74.2091 108 72 108C69.7909 108 68 109.791 68 112C68 114.209 69.7909 116 72 116Z",
    fill: "#ACC1D4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M89 116C91.2091 116 93 114.209 93 112C93 109.791 91.2091 108 89 108C86.7909 108 85 109.791 85 112C85 114.209 86.7909 116 89 116Z",
    fill: "#ACC1D4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M72 75C74.2091 75 76 73.2091 76 71C76 68.7909 74.2091 67 72 67C69.7909 67 68 68.7909 68 71C68 73.2091 69.7909 75 72 75Z",
    fill: "#ACC1D4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M89 75C91.2091 75 93 73.2091 93 71C93 68.7909 91.2091 67 89 67C86.7909 67 85 68.7909 85 71C85 73.2091 86.7909 75 89 75Z",
    fill: "#ACC1D4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M106 75C108.209 75 110 73.2091 110 71C110 68.7909 108.209 67 106 67C103.791 67 102 68.7909 102 71C102 73.2091 103.791 75 106 75Z",
    fill: "#ACC1D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoempty);
export default __webpack_public_path__ + "static/media/roempty.58014e3f.svg";
export { ForwardRef as ReactComponent };